<template>
  <div class="management-page">
    <view-report-modal
        v-model="showViewModal"
        :details="showViewDetails"
        @keydown.esc="closeTransaction"
        @open-refund="showRefundModal = true"
    />

    <base-modal v-model="showRefundModal">
      <refund-modal
          :transaction="transactionDetails"
          @update="handleRefundSuccess"
      />
    </base-modal>

    <form
        v-show="screenMode === 'search'"
        class="mt-4"
        @submit.prevent="formDataCallback"
    >
      <div class="container">
        <!-- hide this until there is so much stuff you have to scroll to see both -->
        <div class="row my-3 d-none">
          <div class="col-12 col-sm-6 col-xl-4">
            <button
                type="submit"
                class="btn btn-primary"
                :disabled="formSubmissionLoading"
            >
              Submit
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card">
              <div class="card-header">Core Details</div>
              <div class="card-body">
                <h6 class="card-title">Date Range</h6>
                <div class="mb-3 row">
                  <div class="col-4">
                    <label for="customDateRangeStart" class="form-label">
                      Start Date
                    </label>
                  </div>
                  <div class="col-8">
                    <div class="float-start" style="width: calc(100% - 24px)">
                      <input
                          id="customDateRangeStart"
                          ref="customDateRangeStart"
                          v-model="customDateRangeStartModel"
                          name="customDateRangeStart"
                          type="date"
                          class="form-control"
                          :required="true"
                      />
                    </div>
                    <div class="float-end">
                      <input
                          :id="'customDateRangeStart' + CHECKBOX_SUFFIX"
                          :name="'customDateRangeStart' + CHECKBOX_SUFFIX"
                          type="checkbox"
                          class="form-check-input"
                          :checked="true"
                          :disabled="true"
                      />
                      <input
                          :name="'customDateRangeStart' + CHECKBOX_SUFFIX"
                          :checked="true"
                          type="checkbox"
                          class="d-none"
                      />
                    </div>
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="col-4">
                    <label for="customDateRangeEnd" class="form-label">
                      End Date
                    </label>
                  </div>
                  <div class="col-8">
                    <div class="float-start" style="width: calc(100% - 24px)">
                      <input
                          id="customDateRangeEnd"
                          ref="customDateRangeEnd"
                          v-model="customDateRangeEndModel"
                          name="customDateRangeEnd"
                          type="date"
                          class="form-control"
                          :required="true"
                      />
                    </div>
                    <div class="float-end">
                      <input
                          :id="'customDateRangeEnd' + CHECKBOX_SUFFIX"
                          :name="'customDateRangeEnd' + CHECKBOX_SUFFIX"
                          type="checkbox"
                          class="form-check-input"
                          :checked="true"
                          :disabled="true"
                      />
                      <input
                          :name="'customDateRangeEnd' + CHECKBOX_SUFFIX"
                          :checked="true"
                          type="checkbox"
                          class="d-none"
                      />
                    </div>
                  </div>
                </div>

                <h6 class="card-title">Predefined Date Range</h6>
                <div class="mb-3 row">
                  <div class="col-4">
                    <label for="predefinedDateRange" class="form-label">
                      Select Period
                    </label>
                  </div>
                  <div class="col-8">
                    <select
                        id="predefinedDateRange"
                        ref="predefinedDateRange"
                        name="predefinedDateRange"
                        class="form-select"
                        @change="updateDatesToMatchPeriod"
                    >
                      <!--
                      <option selected value="">(Select a period)</option>
                      -->
                      <option selected value="day">Today</option>
                      <option value="week">This week</option>
                      <option value="month">This month</option>
                      <option value="last-day">Yesterday</option>
                      <option value="last-week">Last week</option>
                      <option value="last-month">Last month</option>
                    </select>
                  </div>
                </div>

                <!--
                <hr />
                <div class="mb-3 row">
                  <div class="col-4">
                    <label class="form-label">Amount Range</label>
                  </div>
                  <div class="col-8">
                    <div class="float-start" style="width: calc(100% - 24px)">
                      $
                      <input
                        id="amountStart"
                        ref="amountEnd"
                        name="amountStart"
                        type="number"
                        class="form-control currency d-inline"
                        style="width: 80px"
                        min="0"
                        step="0.01"
                        data-number-to-fixed="2"
                        data-number-stepfactor="100"
                      />
                      to $
                      <input
                        id="amountEnd"
                        ref="amountEnd"
                        name="amountEnd"
                        type="number"
                        class="form-control currency d-inline"
                        style="width: 80px"
                        min="0"
                        step="0.01"
                        data-number-to-fixed="2"
                        data-number-stepfactor="100"
                      />
                    </div>
                    <div class="float-end">
                      <input
                        :id="'amount' + CHECKBOX_SUFFIX"
                        :name="'amount' + CHECKBOX_SUFFIX"
                        type="checkbox"
                        class="form-check-input"
                      />
                    </div>
                  </div>
                </div>

                <hr />
                <div class="mb-3 row">
                  <div class="col-4">
                    <label for="paymentMethodNumber" class="form-label">
                      CC/ACH Last 4
                    </label>
                  </div>
                  <div class="col-8">
                    <div class="float-start" style="width: calc(100% - 24px)">
                      <input
                        id="paymentMethodNumber"
                        ref="paymentMethodNumber"
                        name="paymentMethodNumber"
                        type="number"
                        class="form-control currency"
                        min="0"
                        step="1"
                        data-number-to-fixed="0"
                        data-number-stepfactor="1"
                      />
                    </div>
                    <div class="float-end">
                      <input
                        :id="'paymentMethodNumber' + CHECKBOX_SUFFIX"
                        :name="'paymentMethodNumber' + CHECKBOX_SUFFIX"
                        type="checkbox"
                        class="form-check-input"
                      />
                    </div>
                  </div>
                </div>

                <hr />
                <div class="mb-3 row">
                  <div class="col-4">
                    <label for="transactionId" class="form-label">
                      Transaction ID
                    </label>
                  </div>
                  <div class="col-8">
                    <div class="float-start" style="width: calc(100% - 24px)">
                      <input
                        id="transactionId"
                        ref="transactionId"
                        name="transactionId"
                        type="text"
                        class="form-control currency"
                        min="0"
                        step="1"
                        data-number-to-fixed="0"
                        data-number-stepfactor="1"
                      />
                    </div>
                    <div class="float-end">
                      <input
                        :id="'transactionId' + CHECKBOX_SUFFIX"
                        :name="'transactionId' + CHECKBOX_SUFFIX"
                        type="checkbox"
                        class="form-check-input"
                      />
                    </div>
                  </div>
                </div>
                -->
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card">
              <div class="card-header">Merchant & Location Filters</div>
              <div class="card-body">
                <h6 class="card-title">Merchants</h6>
                <div class="mb-3">
                  <div class="pillbox-container mb-2" v-if="selectedMerchants.length > 0">
                  <span
                      v-for="merchant in selectedMerchants"
                      :key="merchant.id"
                      class="badge bg-primary me-1 mb-1"
                      style="cursor: pointer;"
                      @click="removeMerchant(merchant)"
                  >
                    {{ merchant.name }}
                    <span class="ms-1">&times;</span>
                  </span>
                  </div>
                  <select
                      id="merchantSelect"
                      class="form-select"
                      @change="addMerchant"
                  >
                    <option value="">Select a merchant...</option>
                    <option
                        v-for="membership in availableMerchants"
                        :key="membership.merchant.id"
                        :value="membership.merchant.id"
                    >
                      {{ membership.merchant.name }}
                    </option>
                  </select>
                </div>

                <h6 class="card-title">Locations</h6>
                <div class="mb-3">
                  <div class="pillbox-container mb-2" v-if="selectedLocations.length > 0">
                  <span
                      v-for="location in selectedLocations"
                      :key="location.id"
                      class="badge bg-secondary me-1 mb-1"
                      style="cursor: pointer;"
                      @click="removeLocation(location)"
                  >
                    {{ location.merchantName }}: {{ location.name }}
                    <span class="ms-1">&times;</span>
                  </span>
                  </div>
                  <div v-if="locationOptions.length > 0">
                    <select
                        id="locationSelect"
                        class="form-select"
                        @change="addLocation"
                        :disabled="loadingLocations"
                    >
                      <option value="">{{ loadingLocations ? 'Loading locations...' : 'Select a location...' }}</option>
                      <optgroup
                          v-for="merchant in merchantsWithLocations"
                          :key="merchant.id"
                          :label="merchant.name"
                      >
                        <option
                            v-for="location in merchant.locations"
                            :key="location.id"
                            :value="`${merchant.id}|${location.id}`"
                        >
                          {{ location.name }}
                        </option>
                      </optgroup>
                    </select>
                  </div>
                  <div v-else-if="selectedMerchants.length > 0" class="text-muted small">
                    Select merchants to see available locations
                  </div>
                </div>

                <!-- Hidden inputs for form submission -->
                <input
                    v-for="merchant in selectedMerchants"
                    :key="`merchant-${merchant.id}`"
                    type="hidden"
                    :name="`merchants[]`"
                    :value="merchant.id"
                />
                <input
                    v-for="location in selectedLocations"
                    :key="`location-${location.id}`"
                    type="hidden"
                    :name="`locations[]`"
                    :value="location.id"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4 d-none">
            <div class="card">
              <div class="title">Transaction Details</div>
              <div class="card-body">
                <template
                    v-for="(field, index) in [
                  {
                    name: 'transactionType',
                    display: 'Transaction Type'
                  },
                  {
                    name: 'transactionResult',
                    display: 'Transaction Result',
                    type: 'select',
                    options: [
                      { id: true, label: 'Success' },
                      { id: false, label: 'Failure' }
                    ]
                  },
                  {
                    name: 'paymentType',
                    display: 'Payment Type'
                  },
                  {
                    name: 'cardType',
                    display: 'Card Type'
                  },
                  {
                    name: 'cardPresent',
                    display: 'Card Present',
                    type: 'select',
                    options: [
                      { id: 'CP', label: 'Card Present' },
                      { id: 'CNP', label: 'Card Not Present' }
                    ]
                  },
                  {
                    name: 'batchId',
                    display: 'Batch ID'
                  }
                ]"
                    :key="field.name"
                >
                  <hr v-if="index !== 0" />
                  <div class="mb-3 row">
                    <div class="col-4">
                      <label :for="field.name" class="form-label small">{{
                          field.display
                        }}</label>
                    </div>
                    <div class="col-8">
                      <div class="float-start" style="width: calc(100% - 24px)">
                        <input
                            v-if="!field.type || field.type === 'text'"
                            :id="field.name"
                            :name="field.name"
                            type="text"
                            class="form-control form-control-sm"
                        />
                        <select
                            v-if="field.type === 'select'"
                            :id="field.name"
                            :name="field.name"
                            class="form-select form-select-sm"
                        >
                          <option selected value=""></option>
                          <option
                              v-for="option in field.options"
                              :key="option.id"
                              :value="option.id"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                      <div class="float-end">
                        <input
                            :id="field.name + CHECKBOX_SUFFIX"
                            :name="field.name + CHECKBOX_SUFFIX"
                            type="checkbox"
                            class="form-check-input"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-xl-4 d-none">
            <div class="card">
              <div class="card-header">Custom Fields</div>
              <div class="card-body">
                <template
                    v-for="(field, index) in customFields"
                    :key="field.name"
                >
                  <hr v-if="index !== 0" />
                  <div class="mb-3 row">
                    <div class="col-4">
                      <label :for="field.name" class="form-label small">{{
                          field.display
                        }}</label>
                    </div>
                    <div class="col-8">
                      <div class="float-start" style="width: calc(100% - 24px)">
                        <input
                            v-if="!field.type || field.type === 'text'"
                            :id="field.name"
                            :name="'customField:' + field.name"
                            type="text"
                            class="form-control form-control-sm"
                        />
                        <select
                            v-if="field.type === 'select'"
                            :id="field.name"
                            :name="'customField:' + field.name"
                            class="form-select form-select-sm"
                        >
                          <option selected value=""></option>
                          <option
                              v-for="option in field.options"
                              :key="option.id"
                              :value="option.id"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                      <div class="float-end">
                        <input
                            :id="field.name + CHECKBOX_SUFFIX"
                            :name="'customField:' + field.name + CHECKBOX_SUFFIX"
                            type="checkbox"
                            class="form-check-input"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4 d-none">
            <div class="card">
              <div class="card-header">Debug</div>
              <div class="card-body">
                <p class="card-text">{{ formData }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-12 col-sm-6 col-xl-4">
            <button
                type="submit"
                class="btn btn-primary"
                :disabled="formSubmissionLoading"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </form>
    <div v-show="screenMode === 'results'">
      <div class="container">
        <div class="row my-3">
          <div class="col-12 col-sm-6 col-xl-4">
            <button
                type="button"
                class="btn btn-primary"
                @click="refineSearch"
            >
              Refine Search
            </button>
          </div>
        </div>
        <div class="row my-3">
          <!--<div class="col-12 col-sm-6 col-xl-4">-->
          <div class="col-12">
            <div class="row">
              <div class="col">
                <span class="refresh-text float-md-start me-3">
                    &nbsp;&nbsp;TOTAL: <strong>{{ total }}</strong>
                    &nbsp;&nbsp;AVG: <strong>{{ avg }}</strong>
                    &nbsp;&nbsp;COUNT: <strong>{{ count2 }}</strong>
                  </span>
                  <span class="point btn float-md-end" @click="() => agGridApi.exportDataAsExcel({ fileName: 'Transaction Search.xlsx' })">
                    <export :size="20" />
                    <span class="refresh-text">Export Excel</span>
                  </span>
              </div>
            </div>
            <!--
            <div v-for="res in results" :key="res.id">
              {{ res }}
            </div>
            -->
            <!--row-selection="single"-->
            <!--group-display-type="multipleColumns"-->
            <!--:default-col-def="defaultColDef"-->
            <!--:column-defs="columnDefs"-->
            <!--:filter-options="filterOptions"-->
            <!--:side-bar="true"-->
            <!--:status-bar="{}"-->
            <!--:pagination="pagination"-->
            <!--:pagination-auto-page-size="false"-->
            <ag-grid-vue
                ref="agGrid"
                :style="'width:' + '100%' + '; height:' + '75vh' + ';'"
                class="ag-theme-balham"
                :grid-options="{
                  domLayout: 'normal',
                  rowSelection: 'single',
                  groupDisplayType: 'multipleColumns',
                  defaultColDef: {
                    enableRowGroup: true,
                    enablePivot: true,
                    enableValue: true,
                    sortable: true,
                    filter: true,
                    resizable: true,
                    useValueFormatterForExport: true
                  },
                  columnDefs: columnDefs,
                  sideBar: true,
                  // statusBar: {},
                  pagination: true,
                  paginationPageSize: 500,
                  paginationAutoPageSize: true,
                  rowGroupPanelShow: 'onlyWhenGrouping',
                  // autoGroupColumnDef: {
                  //   valueFormatter: ({ value, data }) => 'Grouped ' + value,
                  //   groupMaintainOrder: true,
                  //   field: 'model',
                  //   cellRenderer: 'agGroupCellRenderer',
                  //   cellRendererParams: {
                  //     checkbox: false
                  //   }
                  // },
                  enableRangeSelection: false,
                  excelStyles: [
                    {
                      id: 'dateType',
                      dataType: 'DateTime',
                      numberFormat: { format: 'yyyy-mm-dd hh:mm:ss' }
                    }
                  ],
                  // aggFuncs: ,
                  onGridReady(event) {
                    console.log('ReportingSearchPage.vue onGridReady', event);
                    agGridApi = event.api
                    agGridColumnApi = event.columnApi
                  },
                  onFirstDataRendered(event) {
                    console.log('ReportingSearchPage.vue onFirstDataRendered', event);
                    toolSet();
                  },
                  onFilterChanged(event) {
                    console.log('ReportingSearchPage.vue onFilterChanged', event);
                    toolSet();
                  },
                  onGridColumnsChanged(event) {
                    console.log('ReportingSearchPage.vue onGridColumnsChanged', event);
                  },
                  onRowClicked(event) {
                    console.log('ReportingSearchPage.vue onRowClicked', event);
                  },
                  /**
                   * @param {import('ag-grid-community').RowDoubleClickedEvent<ReportingSearchTransaction>} event
                   */
                  onRowDoubleClicked(event) {
                    console.log('ReportingSearchPage.vue onRowDoubleClicked', event);
                    openViewModal(event.data.transaction_details);
                  },
                }"
            >
            </ag-grid-vue>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import http from '@/services/http';
import { DateTime } from 'luxon';
import { useStore } from 'vuex';
import { AgGridVue } from 'ag-grid-vue3';
import { useRouter } from 'vue-router';
import ViewReportModal from '@/components/reporting/ViewReportModal.vue';
import BaseModal from '@/components/base/BaseModal.vue';
import RefundModal from '@/components/reporting/RefundModal.vue';
import Export from 'vue-material-design-icons/Export.vue';

const CHECKBOX_SUFFIX = 'Use';

const merchantMemberships = computed(() => {
  return store.state.user
      ?.account
      ?.memberships || []
});

const user = computed(() => store.state.user);

/**
 * @typedef {{
 *   id: string
 *   date_time: string
 *   customer: string
 *   transaction_type: string
 *   payment_type: string
 *   account: string
 *   amount: string
 *   status: string
 *   transaction_details: ReportingSearchTransactionDetails
 * }} ReportingSearchTransaction
 */

/**
 * @typedef {{
 *   created_at: string
 *   updated_at: string
 *   amount: string
 *   data: ReportingSearchTransactionDetailsData
 *   client: ReportingSearchTransactionDetailsClient
 * }} ReportingSearchTransactionDetails
 */

/**
 * @typedef {{
 *   api_response: {
 *     original_transaction_id?: string
 *     original_transaction?: ReportingSearchTransactionDetails
 *   } & Record<string, string | Object>
 *   third_party_api_response: Record<string, string | Object>
 * }} ReportingSearchTransactionDetailsData
 */

/**
 * @typedef {{
 *   id: string
 *   name: string
 *   merchant: ReportingSearchTransactionDetailsClientMerchant
 * }} ReportingSearchTransactionDetailsClient
 */

/**
 * @typedef {{
 *   id: string
 *   name: string
 * }} ReportingSearchTransactionDetailsClientMerchant
 */

/**
 * @type {Array<import("ag-grid-community").ColDef | import("ag-grid-community").ColGroupDef>}
 */
const columnDefs = [
  {
    headerName: 'Transaction ID',
    colId: 'transaction_id', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => params.data.id
  },
  {
    headerName: 'Original Transaction ID',
    colId: 'original_transaction_id', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => {
      console.log('valueGetter')
      return params?.data?.transaction_details?.data?.api_response?.original_transaction_id;
    },
    /**
     * @param {import("ag-grid-community").CellClickedEvent<ReportingSearchTransaction, *>} params
     */
    onCellClicked(params) {
      if (params?.data?.transaction_details?.data?.api_response?.original_transaction)
        openViewModal(params?.data?.transaction_details?.data?.api_response?.original_transaction)
    },
  },
  {
    headerName: 'Date',
    colId: 'date_time',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => params.data.date_time
  },
  {
    headerName: 'Merchant',
    colId: 'merchant', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => params.data.transaction_details.client.merchant.name
  },
  {
    headerName: 'Location',
    colId: 'location', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => params.data.transaction_details?.data?.api_response?.sub_location?.name || ""
  },
  {
    headerName: 'Payer',
    colId: 'customer',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => params.data.customer
  },
  {
    initialWidth: 125,
    headerName: 'Transaction Type',
    colId: 'transaction_type',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => params.data.transaction_type
  },
  {
    initialWidth: 125,
    headerName: 'Payment Type',
    colId: 'payment_type',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => params.data.payment_type
  },
  {
    initialWidth: 75,
    headerName: 'Account',
    colId: 'account',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => {
      if (params.data.account) {
        return params.data.account;
      }
      const epxCardNumber = params?.data?.transaction_details?.data?.third_party_api_response?.AUTH_MASKED_ACCOUNT_NBR;
      if (epxCardNumber) {
        return '*' + epxCardNumber.slice(-4);
      }
    }
  },
  {
    initialWidth: 75,
    headerName: 'Amount',
    colId: 'amount',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => params.data.amount
  },
  {
    initialWidth: 125,
    headerName: 'Status',
    colId: 'status',
    filter: 'agTextColumnFilter',
    /** @param {import("ag-grid-community").ValueGetterParams<ReportingSearchTransaction>} params */
    valueGetter: (params) => params.data.status
  },
  {
    headerName: 'RD',
    colId: 'rd', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => params.data.transaction_details?.data?.api_response?.sub_location?.custom_fields?.RD || ""
  },
  {
    headerName: 'VPCO',
    colId: 'vpco', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => params.data.transaction_details?.data?.api_response?.sub_location?.custom_fields?.VPCO || ""
  },
  {
    headerName: 'Sub-Account Number',
    colId: 'subAccountNumber', // 'id',
    filter: 'agTextColumnFilter',
    valueGetter: (params) => params.data.transaction_details?.data?.api_response?.sub_location?.custom_fields?.['Sub-Account Number'] || ""
  },
  /*
  {
    headerName: 'Details',
    colId: 'transaction_details',
    filter: 'agTextColumnFilter',
    // valueGetter: params => params.data.transaction_details,
    cellRenderer: params => `<code>${JSON.stringify(params.data.transaction_details)}</code>`,
  },
 */
];

const store = useStore();
const router = useRouter();

/**
 * @typedef {'search' | 'results'} ScreenMode
 */

/**
 * @type {import('vue').Ref<ScreenMode>}
 */
const screenMode = ref('search');
const customDateRangeStart = ref();
const customDateRangeStartModel = ref();
const customDateRangeEnd = ref();
const customDateRangeEndModel = ref();
const predefinedDateRange = ref();
/**
 * @type {import("vue").Ref<Array<ReportingSearchTransaction>>}
 */
const results = ref([]);
const agGrid = ref();
/** @type {import("vue").Ref<import("ag-grid-community").GridApi>} */
const agGridApi = ref();
/** @type {import("vue").Ref<import("ag-grid-community").ColumnApi>} */
const agGridColumnApi = ref();

const showViewModal = ref(false);
const showRefundModal = ref(false);

/**
 * @type {import("vue").Ref<null | ReportingSearchTransactionDetails>}
 */
const transactionDetails = ref(null);
/**
 * @type {import("vue").Ref<null | ReportingTuple>}
 */
const showViewDetails = ref(null);

const formSubmissionLoading = ref(false);
const formData = ref(null);

// New refs for merchant and location functionality
const selectedMerchants = ref([]);
const selectedLocations = ref([]);
const merchantLocations = ref({});
const loadingLocations = ref(false);

// Totals functionality refs
const avg = ref(0);
const total = ref(0);
const count2 = ref(0);

const availableMerchants = computed(() => {
  return merchantMemberships.value.filter(m =>
      !selectedMerchants.value.find(s => s.id === m.merchant.id)
  );
});

const merchantsWithLocations = computed(() => {
  return selectedMerchants.value
      .filter(m => merchantLocations.value[m.id]?.length > 0)
      .map(m => ({
        id: m.id,
        name: m.name,
        locations: merchantLocations.value[m.id]
      }));
});

const locationOptions = computed(() => {
  return Object.values(merchantLocations.value).flat();
});

/**
 * @param {ReportingSearchTransactionDetails} trx
 * @returns {ReportingTuple}
 */
function trxToTuple(trx) {
  return [trx.created_at, trx, trx.client.merchant.name, trx.client.merchant.parent?.name || 'TriplePlayPay'];
}

/**
 * @param {ReportingSearchTransactionDetails} t
 */
function openViewModal(t) {
  const tuple = trxToTuple(t);

  showViewModal.value = true;
  showViewDetails.value = tuple;
  transactionDetails.value = t;
}

function closeTransaction() {
  showViewModal.value = false;
  showRefundModal.value = false;
}

function handleRefundSuccess() {
  showViewModal.value = false;
  showRefundModal.value = false;
  transactionDetails.value = null;
}

async function addMerchant(event) {
  const merchantId = event.target.value;
  if (!merchantId) return;

  const membership = merchantMemberships.value.find(m => m.merchant.id === merchantId);
  if (membership) {
    selectedMerchants.value.push({
      id: membership.merchant.id,
      name: membership.merchant.name
    });

    // Fetch locations for this merchant
    await fetchLocationsForMerchant(merchantId);
  }

  // Reset select
  event.target.value = '';
}

function removeMerchant(merchant) {
  selectedMerchants.value = selectedMerchants.value.filter(m => m.id !== merchant.id);
  // Remove associated locations
  selectedLocations.value = selectedLocations.value.filter(l => l.merchantId !== merchant.id);
  // Clear cached locations
  delete merchantLocations.value[merchant.id];
}

async function fetchLocationsForMerchant(merchantId) {
  loadingLocations.value = true;
  try {
    const userId = user.value.id;
    const response = await http.get(`/api/rbac/${merchantId}/users/${userId}/sub-entities`);
    merchantLocations.value[merchantId] = response.data.message.map(loc => ({
      id: loc.id,
      name: loc.name,
      merchantId: merchantId
    }));
  } catch (error) {
    console.error('Error fetching locations:', error);
    merchantLocations.value[merchantId] = [];
  } finally {
    loadingLocations.value = false;
  }
}

function addLocation(event) {
  const value = event.target.value;
  if (!value) return;

  const [merchantId, locationId] = value.split('|');
  const merchant = selectedMerchants.value.find(m => m.id === merchantId);
  const location = merchantLocations.value[merchantId]?.find(l => l.id === locationId);

  if (merchant && location) {
    selectedLocations.value.push({
      id: location.id,
      name: location.name,
      merchantId: merchantId,
      merchantName: merchant.name
    });
  }

  // Reset select
  event.target.value = '';
}

function removeLocation(location) {
  selectedLocations.value = selectedLocations.value.filter(l => l.id !== location.id);
}

// Totals calculation function
function toolSet() {
  let tot = 0.0;
  let count = 0;
  let validValueCount = 0;

  // Process each row after filtering
  agGridApi.value.forEachNodeAfterFilter((node) => {
    if (!node.data) return;

    let value = 0;

    // Get transaction details from the nested structure
    const txDetails = node.data.transaction_details;
    if (!txDetails) return;

    // Check ProPay status for special cases
    const proPayStatus = txDetails.pro_pay_status || null;
    const typesToChargeProPayFeeTo = ['ACHInReturned', 'ACHInRejected'];

    if (proPayStatus !== null && typesToChargeProPayFeeTo.includes(proPayStatus)) {
      value = -25.00;
      tot += value;
      validValueCount++;
      count += 1;
      return;
    }

    // Check payment status - skip failed transactions for totaling
    const paymentStatus = node.data.status;
    if (paymentStatus === "Failed" || paymentStatus === "False" || paymentStatus === false || paymentStatus === "DECLINED") {
      return; // Don't count failed transactions
    }

    // Get the action mode/type to determine how to handle the amount
    const actionMode = node.data.transaction_type?.toLowerCase() || '';

    const typesToTotal = ["settle", "debit", "charge", "apple_pay", "terminal", "terminal_charge"];
    const typesToSubtract = ["refund", "void", "blind_refund", "reversal", "credit"];

    // Parse the amount
    const amount = parseFloat(node.data.amount) || 0.0;

    // Determine if we should add or subtract this amount
    if (typesToSubtract.some(type => actionMode.includes(type))) {
      value = -amount;
      tot += value;
      validValueCount++;
      count += 1;
    } else if (typesToTotal.some(type => actionMode.includes(type)) ||
        (actionMode && !typesToSubtract.some(type => actionMode.includes(type)))) {
      // Include in total if it's in typesToTotal OR if it has an action and is not in typesToSubtract
      value = amount;
      tot += value;
      validValueCount++;
      count += 1;
    }
    // If action doesn't match any criteria, don't include in totals
  });

  // Calculate average based on valid values
  let average = 0;
  if (validValueCount > 0) {
    average = tot / validValueCount;
  }

  // Update UI values with proper formatting
  count2.value = count;
  total.value = tot.toFixed(2);
  avg.value = average.toFixed(2);
}

const customFields = computed(() => {
  if (!store.state.allMerchantConfigs) return [];
  let cfValues = Object.values(store.state.allMerchantConfigs)
      .map((e) => e?.configuration?.customizations?.custom_fields)
      .filter(Boolean)
      .flatMap((e) => e);
  let cfUnique = Array.from(new Set(cfValues.map((e) => e.name)));
  return cfUnique.map((e) => ({ name: e, display: e, type: 'text' }));
});

async function submitSearch(searchParams) {
  console.log('submitSearch called with:', searchParams);
  formSubmissionLoading.value = true;
  await router.push('/reporting/search?q=' + btoa(JSON.stringify(searchParams)));
  try {
    console.log('Making API call to /api/v1/report/search');
    let response = await http.post('/api/v1/report/search', searchParams, {
      headers: { 'Content-Type': 'application/json' }
    });

    console.log('API response:', response.data.message);
    results.value = response.data.message.value;
    screenMode.value = 'results';
  } catch (error) {
    console.error('Error submitting search:', error);
  } finally {
    formSubmissionLoading.value = false;
  }
}

// Removed the watch on formData since we're calling submitSearch directly

watch(results, () => {
  let ag = agGrid.value;
  console.log('watched results', agGrid, ag, results, results.value);
  agGridApi.value.setRowData(results.value);
  agGridApi.value.setColumnDefs(columnDefs);
  agGridApi.value.setSideBarVisible(true);
  if (agGridApi.value.isToolPanelShowing()) {
    agGridApi.value.closeToolPanel();
  }
  // Calculate totals when results change
  setTimeout(() => {
    toolSet();
  }, 100);
});

onMounted(() => {
  let value = predefinedDateRange.value.value;
  updateDatesToMatchPeriod({ target: { value } });

  setTimeout(async () => {
    let searchParams = new URL(window.location.href).searchParams;
    if (searchParams.has('q')) {
      const savedFormData = JSON.parse(atob(searchParams.get('q')));
      formData.value = savedFormData;

      // Restore selected merchants and locations if they exist
      if (savedFormData.merchants && savedFormData.merchants.length > 0) {
        savedFormData.merchants.forEach(merchantId => {
          const membership = merchantMemberships.value.find(m => m.merchant.id === merchantId);
          if (membership) {
            selectedMerchants.value.push({
              id: membership.merchant.id,
              name: membership.merchant.name
            });
            fetchLocationsForMerchant(merchantId);
          }
        });
      }

      if (savedFormData.locations && savedFormData.locations.length > 0) {
        // This will be populated after locations are fetched
        setTimeout(() => {
          savedFormData.locations.forEach(locationId => {
            Object.entries(merchantLocations.value).forEach(([merchantId, locations]) => {
              const location = locations.find(l => l.id === locationId);
              if (location) {
                const merchant = selectedMerchants.value.find(m => m.id === merchantId);
                if (merchant) {
                  selectedLocations.value.push({
                    id: location.id,
                    name: location.name,
                    merchantId: merchantId,
                    merchantName: merchant.name
                  });
                }
              }
            });
          });
        }, 1000);
      }

      // Submit the search with the saved data
      await submitSearch(savedFormData);
    }
  }, 100);
});

function updateDatesToMatchPeriod(e) {
  console.log('updateDatesToMatchPeriod');
  switch (e.target.value) {
    case 'day':
    case 'week':
    case 'month': {
      let now = DateTime.now();
      customDateRangeStartModel.value = now
          .startOf(e.target.value)
          .toFormat('yyyy-MM-dd');
      customDateRangeEndModel.value = now.toFormat('yyyy-MM-dd');
      break;
    }
    case 'last-day':
    case 'last-week':
    case 'last-month': {
      let unit = e.target.value.substring('last-'.length);
      let last = DateTime.now().minus({ [unit]: 1 });
      customDateRangeStartModel.value = last
          .startOf(unit)
          .toFormat('yyyy-MM-dd');
      customDateRangeEndModel.value = last.endOf(unit).toFormat('yyyy-MM-dd');
      break;
    }
  }
}

/**
 * @param {SubmitEvent} $event
 */
async function formDataCallback($event) {
  console.log('formDataCallback');
  let rawValues = Object.fromEntries(
      new window.FormData($event.target).entries()
  );
  console.log('inside formDataCallback with rawValues', rawValues);

  let searchParams = {};
  searchParams.customFields = {};

  let checkBoxes = Object.fromEntries(
      Object.entries(rawValues).filter(([k]) => k.endsWith(CHECKBOX_SUFFIX))
  );

  let actualRawValues = Object.fromEntries(
      Object.entries(rawValues).filter(([k]) => !k.endsWith(CHECKBOX_SUFFIX))
  );

  // Get all merchants and locations from FormData
  const formDataObj = new window.FormData($event.target);
  searchParams.merchants = formDataObj.getAll('merchants[]');
  searchParams.locations = formDataObj.getAll('locations[]');

  for (let key in actualRawValues) {
    // Skip array fields and unchecked checkboxes
    if (key.includes('[]') || (checkBoxes[key + CHECKBOX_SUFFIX] !== 'on' && !key.includes('[]'))) continue;

    if (key.startsWith('customField:')) {
      searchParams.customFields[key.substring('customField:'.length)] =
          rawValues[key];
    } else {
      searchParams[key] = rawValues[key];
    }
  }

  // Clean up empty custom fields
  if (Object.keys(searchParams.customFields).length === 0 ||
      Object.keys(searchParams.customFields).every(k => k === 'undefined' || !searchParams.customFields[k])) {
    delete searchParams.customFields;
  }

  let original_customDateRangeStart = searchParams['customDateRangeStart']
  if (original_customDateRangeStart) {
    searchParams['customDateRangeStart'] = fixUpCdrDate(original_customDateRangeStart, false);
  }
  let original_customDateRangeEnd = searchParams['customDateRangeEnd']
  if (original_customDateRangeEnd) {
    searchParams['customDateRangeEnd'] = fixUpCdrDate(original_customDateRangeEnd, true);
  }

  console.log('Final searchParams:', searchParams);

  // Update formData ref for potential other uses
  formData.value = searchParams;

  // Call submitSearch directly instead of relying on watch
  await submitSearch(searchParams);
}

function fixUpCdrDate(original, isEndDate = false) {
  if (isEndDate) {
    // For end date, set to 23:59:59.999
    return new Date(original + 'T23:59:59.999Z').getTime();
  } else {
    // For start date, set to 00:00:00
    return new Date(original + 'T00:00:00.000Z').getTime();
  }
}

async function refineSearch() {
  screenMode.value = 'search';
  await router.push('/reporting/search');
}
</script>
<style scoped>
.pillbox-container {
  min-height: 32px;
  padding: 4px;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  background-color: #f8f9fa;
}

.badge {
  font-size: 0.875rem;
  font-weight: normal;
  padding: 0.375rem 0.75rem;
}

.badge:hover {
  opacity: 0.8;
}

.point {
  cursor: pointer;
}

.refresh-text {
  font-size: 14px;
  color: var(--c-dark);
  vertical-align: middle;
  margin-left: 5px;
}
</style>